import { createSvgIcon } from "./create-svg-icon";

export const Packages = createSvgIcon(
  <svg viewBox="-0.5 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0298 5.04309H3.02979V6.53119H15.0298V5.04309Z" fill="currentColor" />
    <path d="M13.5148 2.06689H4.50732V3.55499H13.5148V2.06689Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 9.49994V8.01184H16.5V9.49994H15V15.4523C15 16.2742 14.3284 16.9404 13.5 16.9404H4.5C3.67157 16.9404 3 16.2742 3 15.4523V9.49994H1.5ZM4.5 14.7083H8.25V13.2202H4.5V14.7083Z"
      fill="currentColor"
    />
  </svg>,
);
